export const SET_BUNDLE_DETAILS = "SET_BUNDLE_DETAILS";

const initialState = {
  allUserBundles: [],
  isBundleLoading: true,
  refetchAfterUserBundleSubs: false,
  openUserBundlePlanData: false,
  currentUserBundle: {},
  selectedUBSubs: null,
  UBsubsBtnDisable: false,
  openUserBundleConfirmModal: false,
  currentUserBundleDetail: {},

  allTokenBundles: [],
  isTBundleLoading: true,
  refetchAfterTokenBundleSubs: false,
  openTBundlePlanData: false,
  currentTBundle: {},
  selectedTBSubs: null,
  TBsubsBtnDisable: false,
  currentTBundleDetail: {},
  showDetailModal: false,

  plan_type: "module-plan",
  allPaidUserBundles: [],
  allPaidTokenBundles: [],
  TBSubscriptionSuccess: true,
  finalSubsTokenData: {},
  UBPurchaseBtn: false,
};

export default (state = initialState, action = {}) => {
  if (action.type === "SET_BUNDLE_DETAILS") {
    return { ...state, ...action.payload };
  } else {
    return state;
  }
};
